/**
 * Vocabulary of the paused-activity filter's "what counts as activity" kinds.
 * Keys are the SERVER tokens (`?idleTouches=` — lead.filter.ts idleOpenFor);
 * labels are what the panel checkboxes and the applied chip render.
 *
 * "" (no selection stored) means ALL kinds — the report widget's definition —
 * so only a real subset is ever serialized or shown as applied.
 */
export const IDLE_TOUCH_OPTIONS = [
  {
    key: "updates",
    label: "Lead & deal updates",
    hint: "Field edits, stage/status moves, assignments — on the lead or any deal. Automation-driven changes never count.",
  },
  {
    key: "followups",
    label: "Follow-ups",
    hint: "A follow-up scheduled or rescheduled on the lead or any deal",
  },
  {
    key: "notes",
    label: "Notes",
    hint: "A note added on the lead or any deal",
  },
  {
    key: "calls",
    label: "Call logs",
    hint: "Any call logged on the lead",
  },
] as const;

export type IdleTouchKey = (typeof IDLE_TOUCH_OPTIONS)[number]["key"];

export const ALL_IDLE_TOUCH_KEYS: string[] = IDLE_TOUCH_OPTIONS.map(
  (o) => o.key
);

/** Parse the stored comma string; "" (default) expands to ALL kinds. */
export function parseIdleTouches(value: string | null | undefined): string[] {
  const picked = String(value ?? "")
    .split(",")
    .map((t) => t.trim())
    .filter((t) => ALL_IDLE_TOUCH_KEYS.includes(t));
  return picked.length ? picked : [...ALL_IDLE_TOUCH_KEYS];
}

/** Human-readable list for chips/summaries, e.g. "Follow-ups, Notes". */
export function idleTouchesLabel(value: string | null | undefined): string {
  const picked = parseIdleTouches(value);
  return IDLE_TOUCH_OPTIONS.filter((o) => picked.includes(o.key))
    .map((o) => o.label)
    .join(", ");
}
